<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
<app-navbar-user 
    [page]="{ title: 'Analytics', link: ['/analytics'] }"
    [subpage]="'Journey #' + session?.session_id"></app-navbar-user>
<app-sidenav [active]="'analytics'"></app-sidenav>
<div class="content-container mt-0 main-content" *ngIf="session">

    <div class="float-end d-flex" style="gap:.5rem;">

        <div class="position-relative" dropdown>
            <button id="button-viewMode" dropdownToggle type="button" class="btn btn-sm btn-darken"
                aria-controls="dropdown-viewMode">
                <i class='bx bx-list-ul'></i> View
            </button>
            <ul id="dropdown-viewMode" *dropdownMenu class="dropdown-menu dropdown-menu-end dropdown-menu-sm"
                role="menu" aria-labelledby="button-viewMode">
                <li role="menuitem">
                    <a class="dropdown-item d-flex align-items-center text-dark" (click)="viewMode='tabbed'"
                        [ngClass]="{'selected' : viewMode =='tabbed'}">

                        <i class="bx bx-check" [ngClass]="{ invisible: viewMode != 'tabbed' }"></i>
                        Tabbed </a>
                </li>
                <li role="menuitem">
                    <a class="dropdown-item d-flex align-items-center text-dark" (click)="viewMode='all'"
                        [ngClass]="{'selected' : viewMode =='all'}">

                        <i class="bx bx-check" [ngClass]="{ invisible: viewMode != 'all' }"></i>
                        Show all </a>
                </li>
            </ul>
        </div>


        <!--a href="/journey/{{ session.session_id }}:{{ session.scenario_id }}:{{
          session.published_hash
        }}" target="_blank" class="btn btn-sm btn-darken"><i class="bx bx-link-external"></i> Shareable link</a-->
    </div>



    <h2 class="m-0 page-title mb-3"><i class='bx bx-line-chart btn-icon'></i> Scenario Session #{{session.session_id}}
    </h2>

    <div class="row">
        <div class="col-xl-3 d-flex">
            <div>
                <div class="row" *ngIf="session">
                    <div class="col-sm-12">
                        <div class="card mb-4 shadow-sm analytics-stat">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col mt-0">
                                        <h5 class="card-title">Date played</h5>
                                    </div>
                                    <div class="col-auto">
                                        <span class="dashboard-stat-icon-alt"><i class="bx bx-calendar"></i></span>
                                    </div>
                                </div>
                                <div class="my-1">{{ session.created | date }}</div>
                            </div>
                        </div>
                        <div class="card mb-4 shadow-sm analytics-stat" *ngIf="session?.step_id">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col mt-0">
                                        <h5 class="card-title">End Step</h5>
                                    </div>
                                    <div class="col-auto">
                                        <span class="dashboard-stat-icon-alt"><i class="bx bx-sitemap"></i></span>
                                    </div>
                                </div>
                                <div class="my-1"><ng-container *ngIf="session.step_id">{{ getStep(session.step_id,
                                        scenario) ?
                                        getStep(session.step_id, scenario)?.title :
                                        'Deleted Step' }}</ng-container>
                                    <ng-container *ngIf="!session.step_id">None</ng-container>
                                </div>
                                <!--div class="mb-0 small">
                                    <span class="badge bg-info me-1">
                                        {{getStep(stats.topEndStep, scenario) ?
                                        getStep(stats.topEndStep, scenario)?.title :
                                        'Deleted Step' }}
                                    </span> <span class="text-muted">Most common</span>
                                </div-->
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="card mb-4 shadow-sm analytics-stat" *ngIf="session.score">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col mt-0">
                                        <h5 class="card-title">Score</h5>
                                    </div>

                                    <div class="col-auto">
                                        <span class="dashboard-stat-icon-alt"><i class="bx bx-check-double"></i></span>
                                    </div>
                                </div>
                                <div class="my-1">{{ session.score | number : "1.0-0" }}</div>
                                <div class="mb-0 small">
                                    <span class="badge  me-1"
                                        [ngClass]="{'bg-danger' :  session.score - stats.averageScore <0, 'bg-info' : session.score - stats.averageScore  == 0, 'bg-success' : session.score - stats.averageScore >0 }"><ng-container
                                            *ngIf="session.score - stats.averageScore >=0">+</ng-container>{{(session.score
                                        - stats.averageScore) | number}}</span>
                                    <span class="text-muted">Compared to average</span>
                                </div>
                            </div>
                        </div>
                        <div class="card mb-4 shadow-sm analytics-stat">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col mt-0">
                                        <h5 class="card-title">Time spent</h5>
                                    </div>

                                    <div class="col-auto">
                                        <span class="dashboard-stat-icon-alt"><i class="bx bx-stopwatch"></i></span>
                                    </div>
                                </div>
                                <div class="my-1">{{ session.duration | formatDuration : 's' : 'd:h:m:ss:LongSmart' }}
                                </div>
                                <!--div class="mb-0 small">
                                    <span class="badge  me-1"
                                        [ngClass]="{'bg-danger' : session.duration - stats.averageTime  <=-0.5, 'bg-info' : session.duration - stats.averageTime >-0.5 && session.duration - stats.averageTime < 0.5, 'bg-success' : session.duration - stats.averageTime >=0.5 }"><ng-container
                                            *ngIf="session.duration - stats.averageTime >0">+</ng-container>{{(session.duration
                                        -
                                        stats.averageTime) | formatDuration : 's' : 'd:h:m:ss:LongSmartNoZero'}}</span>
                                    <span class="text-muted">Compared to average</span>
                                </div-->
                            </div>
                        </div>
                        <!--div class="card mb-4 shadow-sm analytics-stat" *ngIf="hasVars(session)">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col mt-0">
                                        <h5 class="card-title">Variables</h5>
                                    </div>
                                    <div class="col-auto">
                                        <span class="dashboard-stat-icon-alt"><i class="bx bx-code-curly"></i></span>
                                    </div>
                                </div>
                                <table class="data-table data-table-alt table table-borderless table-hover table-sm">
                                    <ng-container *ngFor="let _var of session.vars">
                                        <tr *ngIf="_var.name != 'score' && _var.name != 'user'">
                                            <td>{{ _var.name }}</td>
                                            <th>{{ _var.value }}</th>
                                        </tr>
                                    </ng-container>
                                </table>
                            </div>
                        </div-->
                    </div>

                </div>
            </div>
        </div>

        <div class="col-xl-9">
            <tabset *ngIf="viewMode=='tabbed'">
                <tab [heading]="'Route'" *ngIf="session.route && session.route.length>0">
                    <div class="card  w-100 shadow-sm mb-4" *ngIf="session.route && session.route.length>0">
                        <div class="card-header">
                            <h5 class="card-title mb-0">Route</h5>
                        </div>
                        <div class="card-body pt-2 pb-3">
                            <app-session-route [scenario]="scenario" [session]="session"></app-session-route>
                        </div>
                    </div>
                </tab>
                <tab [heading]="'User Responses'" *ngIf="taskResponses && taskResponses.length>0">
                    <app-session-responses [taskResponses]="taskResponses"></app-session-responses>
                </tab>
                <tab [heading]="'Event Log'" *ngIf="log">
                    <div class="card  w-100 shadow-sm mb-4">
                        <div class="card-header d-flex justify-content-between">
                            <div style="width:125px;">
                            </div>
                            <h5 class="card-title mb-0">Event Log</h5>

                            <div style="text-transform: none;">
                                <div class="position-relative mb-2" dropdown [insideClick]="true">
                                    <button id="button-filter" dropdownToggle type="button"
                                        class="btn btn-sm btn-darken" aria-controls="dropdown-filter">
                                        <i class="bx bx-filter"></i> Filter Data
                                        <span
                                            class="badge rounded-pill bg-dark badge-sm ng-star-inserted">{{journeyFilter.length}}</span>
                                    </button>
                                    <ul id="dropdown-filter" *dropdownMenu
                                        class="dropdown-menu dropdown-menu-end dropdown-menu-sm" role="menu"
                                        aria-labelledby="button-filter">
                                        <li role="menuitem" *ngFor="let event of eventTypes">
                                            <a class="dropdown-item d-flex align-items-center text-dark"
                                                (click)="onToggleFilterEvent(event)"
                                                [ngClass]="{'selected' : journeyFilter.indexOf(event.id)!==-1}">
                                                <i class="bx bx-checkbox me-1" style="font-size:1rem;"
                                                    *ngIf="journeyFilter.indexOf(event.id)==-1"></i>
                                                <i class="bx bx-checkbox-checked me-1" style="font-size:1rem;"
                                                    *ngIf="journeyFilter.indexOf(event.id)!==-1"></i>
                                                {{event.label}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card-body pt-2 pb-3">
                            <app-session-log [scenario]="scenario" [session]="session" [journeyFilter]="journeyFilter"
                                [log]="log" [enableComments]="true"></app-session-log>
                        </div>
                    </div>
                </tab>
            </tabset>

            <div *ngIf="viewMode == 'all'">

                <div class="card  w-100 shadow-sm mb-4" *ngIf="session.route && session.route.length>0">
                    <div class="card-header">
                        <h5 class="card-title mb-0">Route</h5>
                    </div>
                    <div class="card-body pt-2 pb-3">

                        <app-session-route [scenario]="scenario" [session]="session"></app-session-route>

                    </div>
                </div>
                <app-session-responses [taskResponses]="taskResponses"></app-session-responses>

                <div class="card  w-100 shadow-sm mb-4">
                    <div class="card-header d-flex justify-content-between">
                        <div style="width:125px;">

                        </div>
                        <h5 class="card-title mb-0">Event Log</h5>

                        <div style="text-transform: none;">
                            <div class="position-relative mb-2" dropdown [insideClick]="true">
                                <button id="button-filter" dropdownToggle type="button" class="btn btn-sm btn-darken"
                                    aria-controls="dropdown-filter">
                                    <i class="bx bx-filter"></i> Filter Data
                                    <span
                                        class="badge rounded-pill bg-dark badge-sm ng-star-inserted">{{journeyFilter.length}}</span>
                                </button>
                                <ul id="dropdown-filter" *dropdownMenu
                                    class="dropdown-menu dropdown-menu-end dropdown-menu-sm" role="menu"
                                    aria-labelledby="button-filter">
                                    <li role="menuitem" *ngFor="let event of eventTypes">
                                        <a class="dropdown-item d-flex align-items-center text-dark"
                                            (click)="onToggleFilterEvent(event)"
                                            [ngClass]="{'selected' : journeyFilter.indexOf(event.id)!==-1}">
                                            <i class="bx bx-checkbox me-1" style="font-size:1rem;"
                                                *ngIf="journeyFilter.indexOf(event.id)==-1"></i>
                                            <i class="bx bx-checkbox-checked me-1" style="font-size:1rem;"
                                                *ngIf="journeyFilter.indexOf(event.id)!==-1"></i>
                                            {{event.label}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-body pt-2 pb-3">
                        <app-session-log [scenario]="scenario" [session]="session" [journeyFilter]="journeyFilter"
                            [log]="log" [enableComments]="true"></app-session-log>
                    </div>
                </div>
            </div>
        </div>



    </div>
</div>
<app-footer></app-footer>